var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log, parseDataFile, getExtension } from "../../exports/helpers.js";
export default function loadDataFromUrlWeb(url, autoType = false, dataAsArrays = false, firstItem = 0, lastItem = Infinity, nbFirstRowsToExclude = 0, nbLastRowsToExclude = Infinity, fillMissingKeys = false, fileNameAsId = false, missingKeyValues = {
    null: null,
    NaN: NaN,
    undefined: undefined,
}, verbose = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const urls = [];
        const arrayOfObjects = [];
        if (typeof url === "string") {
            urls.push(url);
        }
        else {
            urls.push(...url);
        }
        for (const url of urls) {
            verbose && log(`Fetching ${url}...`, "blue");
            const request = yield fetch(url);
            const data = yield request.text();
            const fileExtension = getExtension(url, verbose);
            const parsedData = parseDataFile(data, fileExtension, autoType, dataAsArrays, firstItem, lastItem, nbFirstRowsToExclude, nbLastRowsToExclude, fillMissingKeys, missingKeyValues, verbose);
            if (fileNameAsId) {
                const filePathSplit = url.split("/");
                const fileName = filePathSplit[filePathSplit.length - 1];
                for (let i = 0; i < parsedData.length; i++) {
                    parsedData[i].id = fileName;
                }
            }
            for (let i = 0; i < parsedData.length; i++) {
                arrayOfObjects.push(parsedData[i]);
            }
        }
        return arrayOfObjects;
    });
}
//# sourceMappingURL=loadDataFromUrlWeb.js.map